import {
  type AssetProjectIdentifier,
  type AssetProjectUpdateDto
} from '../../api-schema-types/assets/AssetProjectCrudDtos'
import { type AssetProjectSummary } from '../../api-schema-types/assets/AssetProjectDomainDtos'
import { type ProjectsFilterProps } from './projectApi'

 
export const projectsApiMapper = () => {
  const projectSummaryListMapper = (responseData: AssetProjectSummary[], meta: any, args: ProjectsFilterProps): AssetProjectSummary[] => {
    if (args.showInactiveProjects) {
      return responseData
    } else {
      return responseData.filter((asp) => asp.projectCrowdsaleStatus !== null)
    }
  }

  const projectCrudMapper = (responseData: AssetProjectUpdateDto, meta: any, args: any): AssetProjectUpdateDto => {
    const values = { ...responseData }
    // We map nulls to ZERO here for the select component. See EditSolarProjectForm.
    values.organisations.charityMemberId ??= 0
    values.organisations.solarInstallerId ??= 0
    values.organisations.solarConsumerId ??= 0
    values.website.marketingSector ??= ''
    return values
  }

  const projectIdentifierMapper = (responseData: AssetProjectIdentifier, meta: any, args: any): AssetProjectIdentifier => {
    return responseData
  }

  return {
    projectSummaryListMapper,
    projectDetailsMapper: projectCrudMapper,
    projectIdentifierMapper
  }
}
